<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-22 23:53:33
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-13 14:26:38
 * @FilePath: /gamefi/components/Casino/GameSettings/Button/Fast.vue
 * @Description: 设定游戏是否开启快速模式 
-->
<template>
    <GameSettingsButtonWrapper
        :tool-tip="t.Fast"
        :enable="modelValue"
        @click="onClick()"
    >
        <IconSvgUse use="icon-speed" class="w-[14px] h-[14px]" name="rocket" />
    </GameSettingsButtonWrapper>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import useSettingsStore from '~/stores/settings';

const t = useTranslation();
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    gameName: {
        type: String,
        default: '',
        required: false
    },
    isBetting: {
        type: Boolean,
    },
});
const emit = defineEmits(['update:modelValue']);

const onClick = () => {
    console.log('props.modelValue changing from:', props.modelValue);
    // tower游戏只有在auto mode时才支持fast mode
    const stopForTower = (
        props.gameName === 'tower'
        && !useSettingsStore().game.tower.auto.default
        && !props.modelValue
    ); 
    const plinkoGaming = (
        props.gameName === 'plinko'
        && !!props.isBetting
        && !props.modelValue // 当前为非快速模式（试图切到快速模式） 
    );
    let i18n = '';
    if (stopForTower){
        i18n = 'FastModeNitify';
    }else if (plinkoGaming){
        i18n = 'FastModeDisabled';
    }
    if (i18n){
        return showNegativeNotify({
            type: 'warning',
            position: 'top',
            i18n,
        });
    }
    emit('update:modelValue', !props.modelValue);
};
</script>
